// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInISOWeekYears as fn } from "../differenceInISOWeekYears.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInISOWeekYearsWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default differenceInISOWeekYearsWithOptions;
